export const payrollKeys = {
  all: ['payroll'] as const,
  runs: () => [...payrollKeys.all, 'runs'] as const,
  run: (id: string) => [...payrollKeys.runs(), id] as const,
  employees: (startDate: string, endDate: string) => 
    [...payrollKeys.all, 'employees', startDate, endDate] as const,
} as const;
